import { render, staticRenderFns } from "./card-select-products.vue?vue&type=template&id=3fc82d15&"
import script from "./card-select-products.vue?vue&type=script&lang=js&"
export * from "./card-select-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports